import React, { useMemo, useState } from "react"
import { useQuery } from "react-query"
import { getDisbursedLoans } from "services/LoanService"
import FilterComp from "../FilterComp"
// import { TableContainer, TableDiv } from "../style"
import { DISCOLUMNS } from "./disColumns"
// import EmptyData from "components/Emptydata"
// import SectionLoader from "components/SectionLoader"
// import useAdminData from "hooks/useAdminData"
import DownloadCSVBtn from "../AcctAcceptedLoans/DownloadCsvBtn"
import { Table } from "antd"
import { usePaginate } from "hooks/usePagination"
import { useDownloadForm } from "components/Download/useDownloadForm"


const DisLoansComp = () => {
	const {handleDownloadByType} = useDownloadForm()
	const {page,setPage,setLimit,limit} = usePaginate()
	const [query, updateSearchQuery] = useState("")
	const { data: res, isLoading } = useQuery(
		["disbursed-loans",page,limit,query],
		()=>getDisbursedLoans({page,limit,search:query}))


	const setQuery = (queryString)=>{
		updateSearchQuery(queryString)
		setPage(1)
		setLimit(10)
	}

	const columns = useMemo(() => DISCOLUMNS, [])
	const data = useMemo(() => {
		const disbLoanna = res?.data?.loans
		? res?.data?.loans?.filter(
			(loan)=>{
				return true
			}
		)
		: []
		return disbLoanna
	}, [res,query])

	const pagination = useMemo(()=>{
				return {
					nextPageUrl:null,
					offset:0,
					limit:10,
					total:res?.data?.total ?? 10,
					page:1,
					prevPage:null,
					prevPageUrl:null,
					nextPage:null,
					totalPages:1,
					...res?.data?.pagination
				}
			},[res])
	
		const tablePagination ={
			total:pagination.total,
			current:pagination.page,
			onShowSizeChange:(_,size)=>{
				setLimit(size)
			},
			onChange:(pageNumber)=>{
				setPage(pageNumber)
			},
			pageSize:limit,
			nextIcon:()=>{
				const next = ()=> pagination.nextPage? setPage(pagination.nextPage) :undefined
				if(!pagination.nextPage) return null;
				return (
					<button onClick={next}> <i className="bi bi-chevron-right"></i></button>
				)
			},
			prevIcon:()=>{
				const prev = ()=> pagination.prevPage? setPage(pagination.prevPage) :undefined
				if(!pagination.prevPage) return null;
				return (
					<button onClick={prev}> <i className="bi bi-chevron-left"></i></button>
				)
			}
		}


	return (
		<>
			<header className="flex items-center justify-between my-3">
				<FilterComp setFilter={setQuery} filter={query}/>
				<div className="flex items-center gap-x-4">
					{/* <button className="bg-primary text-white px-6 py-2 rounded-lg" onClick={()=>handleDownloadByType("disbursed")}>Download All ({pagination.total})</button> */}
					<DownloadCSVBtn data={data} fileName="disbursed" title={`Download Page ${page}`}/>
				</div>
			</header>
			<div>
				<Table
				 scroll={{ x: 'max-content' }}
				loading={isLoading}
				pagination={tablePagination}
				columns={columns} dataSource={data}/>
			</div>
		</>
	)
}

export default DisLoansComp
